/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createFormat } from '../../factoriesAny.js';
export var formatDependencies = {
  typedDependencies,
  createFormat
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/esm/entry/dependenciesAny/dependenciesFormat.generated.js
// module id = null
// module chunks = 